import { NAME } from './constants';

export const ACTIVATE_DATA = `${NAME}/ACTIVATE_DATA`;
export const DISCARD_DATA = `${NAME}/DISCARD_DATA`;
export const EDIT_DATA = `${NAME}/EDIT_DATA`;
export const SET_CAMPAIGN_ADDITIONAL_DATA = `${NAME}/SET_CAMPAIGN_ADDITIONAL_DATA`;
export const UPDATE_CAMPAIGN_ADDITIONAL_DATA = `${NAME}/UPDATE_CAMPAIGN_ADDITIONAL_DATA`;
export const REVERT_CHANGES = `${NAME}/REVERT_CHANGES`;
